module.exports = () => window.location.hostname.includes('sendcrypto');
